/* Flavour catalogue — loaded as a plain script before cookie-hunt-game.js.
   Sprite paths are relative fallbacks; the Liquid section overrides them at
   runtime via window.__GAME_ASSETS__ so Shopify CDN URLs are used instead.
*/
window.__FLAVOURS__ = [
  {id:"CCrunch", name:"Caramelised Crunch", w:7, p:25,
   sprite:"assets/cookies/CCrunch.webp",
   colours:{accent:"#b4602d", base:"#a96d4a", dark:"#47301f"}},

  {id:"Coconut", name:"Coconut", w:7, p:25,
   sprite:"assets/cookies/Coconut.webp",
   colours:{accent:"#b9863f", base:"#cd956a", dark:"#56432d"}},

  {id:"DarkChoc", name:"Dark Chocolate Chunk", w:8, p:20,
   sprite:"assets/cookies/DarkChoc.webp",
   colours:{accent:"#4a3127", base:"#c98f57", dark:"#2c1a10"}},

  {id:"DoubleChocChunk", name:"Double Chocolate Chunk", w:9, p:15,
   sprite:"assets/cookies/DoubleChocChunk.webp",
   colours:{accent:"#5c3a2e", base:"#9d6c50", dark:"#3b2418"}},

  {id:"Ginger_DarkChoc", name:"Ginger & Dark Chocolate", w:4, p:45,
   sprite:"assets/cookies/Ginger_DarkChoc.webp",
   colours:{accent:"#b5702a", base:"#cb8a3f", dark:"#553a1a"}},

  {id:"MilkChocChunk", name:"Milk Chocolate Chunk", w:10, p:10,
   sprite:"assets/cookies/MilkChocChunk.webp",
   colours:{accent:"#8a5a3c", base:"#cc8c5a", dark:"#5c3b22"}},

  {id:"MilkChocOrange", name:"Orange & Milk Chocolate", w:6, p:30,
   sprite:"assets/cookies/MilkChocOrange.webp",
   colours:{accent:"#d2682a", base:"#d68a44", dark:"#5e2f17"}},

  {id:"PralineMilkChoc", name:"Praline & Milk Chocolate", w:4, p:45,
   sprite:"assets/cookies/PralineMilkChoc.webp",
   colours:{accent:"#a9713f", base:"#c98a52", dark:"#523323"}},

  {id:"TripleChocChunk", name:"Triple Chocolate Chunk", w:2, p:70,
   sprite:"assets/cookies/TripleChocChunk.webp",
   colours:{accent:"#4a2f28", base:"#7a4f3c", dark:"#2a1812"}},

  {id:"WhiteChocChunk", name:"White Chocolate Chunk", w:6, p:30,
   sprite:"assets/cookies/WhiteChocChunk.webp",
   colours:{accent:"#c9a24b", base:"#d8a766", dark:"#5f4423"}},
];
